export let CardComputed = {
    contentLink() {
        const routerName = this.content.content_type === 0 ? 'SinglePage' : 'SinglePost';
        return {name: routerName, params: {slug: this.content.slug}}
    }
}